import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function PainBridge() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-12 md:py-20" data-id="element-470">
      <div className="max-w-3xl mx-auto px-6" data-id="element-471">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="space-y-7" data-id="element-472">
          <p className="font-serif text-2xl md:text-3xl text-white font-semibold leading-relaxed" data-id="element-473">
            Do you feel like reality has a deeper layer — but no one has shown
            you how to see it?
          </p>

          <div className="space-y-5 pl-5 border-l-2 border-neutral-800/60" data-id="element-474">
            <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-475">
              You searched in <strong className="text-white" data-id="element-476">religion</strong> —
              and found rules without answers.
            </p>
            <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-477">
              You searched in <strong className="text-white" data-id="element-478">science</strong> —
              and found answers without meaning.
            </p>
            <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-479">
              You searched in <strong className="text-white" data-id="element-480">self-help</strong>{' '}
              — and found a better version of the same trapped life.
            </p>
          </div>

          <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-481">
            Something inside you knows a bridge exists between the visible and
            invisible world — between what you feel in your deepest moments and
            what can actually be explained.
          </p>

          <div className="py-6 px-8 rounded-xl bg-gradient-to-r from-teal-500/10 to-transparent border-l-4 border-teal-500" data-id="element-482">
            <p className="font-serif text-xl md:text-2xl text-white font-semibold leading-relaxed italic" data-id="element-483">
              That bridge exists. This book is the map to cross it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}